import React, { useState } from "react";
import useControlOptions from "../../../../hooks/useControlOptions";
import SimpleColors from "./Colors/SimpleColors";
import GradientColors from "./Colors/GradientColors";
import TrackingModal from "./TrackingModal";

const ControlOptions = ({ setQrOptions, qrOptions }) => {
    const {
        isColorOptionsVisible,
        toggleColorOptions,
        isDotsOptionsVisible,
        toggleDotsOptions,
        colorMode,
        handleColorModeChange,
        gradientType,
        handleGradientTypeChange
    } = useControlOptions();

    const [isTrackingModalOpen, setIsTrackingModalOpen] = useState(false);

    const handleTrackingClick = () => {
        setIsTrackingModalOpen(true);
    };

    const handleTrackingModalClose = () => {
        setIsTrackingModalOpen(false);
    };

    const handleColorChange = (e) => {
        const value = e.target.value;
        setQrOptions(prevOptions => ({ ...prevOptions, color: value, colorMode: "simple" }));
    };

    const handleBgColorChange = (e) => {
        const value = e.target.value;
        setQrOptions(prevOptions => ({ ...prevOptions, bgColor: value }));
    };

    const handleGradientColorChange = (e, index) => {
        const value = e.target.value;
        setQrOptions(prevOptions => {
            const newGradientColors = [...(prevOptions.gradientColors || ["#000000", "#ffffff"])];
            newGradientColors[index] = value;
            return { ...prevOptions, gradientColors: newGradientColors, colorMode: "gradient" };
        });
    };

    const handleGradientTypeChangeWithUpdate = (type) => {
        handleGradientTypeChange(type);
        setQrOptions(prevOptions => ({ ...prevOptions, gradientType: type }));
    };

    const handleDotsTypeChange = (type) => {
        setQrOptions(prevOptions => ({ ...prevOptions, dotsType: type }));
    };

    const handleColorModeChangeWithUpdate = (mode) => {
        handleColorModeChange(mode);
        if (mode === "gradient") {
            setQrOptions(prevOptions => ({ ...prevOptions, colorMode: "gradient" }));
        } else {
            setQrOptions(prevOptions => ({ ...prevOptions, colorMode: "simple" }));
        }
    };

    return (
        <div className="controls-options">
            
            <div className="form-group toggle-tracking-options" onClick={handleTrackingClick}>
                <div className="toggle-switch">
                    <input type="checkbox" id="tracking-checkbox" disabled />
                    <label htmlFor="tracking-checkbox" className="toggle-label">
                        <span className="toggle-button"></span>
                    </label>
                </div>
                <span>Ativar rastreabilidade e estatísticas</span>
            </div>
            <div className="form-group toggle-color-options" onClick={toggleColorOptions}>
                <i id="toggle-color-options" className="fas fa-palette change-icon" title="Selecionar Cores"></i>
                <span>Selecionar cores</span>
            </div>
            
            <div id="color-options" className="color-controls" style={{ display: isColorOptionsVisible ? 'flex' : 'none' }}>
                <div className="form-group">
                    <label>
                        <input type="radio" name="color-mode" value="simple" checked={colorMode === "simple"} onChange={() => handleColorModeChangeWithUpdate("simple")} />
                        Cores Simples
                    </label>
                    <label>
                        <input type="radio" name="color-mode" value="gradient" checked={colorMode === "gradient"} onChange={() => handleColorModeChangeWithUpdate("gradient")} />
                        Cores Gradiente
                    </label>
                </div>
                {colorMode === "simple" && (
                    <SimpleColors qrOptions={qrOptions} handleColorChange={handleColorChange} handleBgColorChange={handleBgColorChange} />
                )}
                <div className="form-group">
                    <label htmlFor="qr-bg-color">Cor de Fundo</label>
                    <input type="color" id="qr-bg-color" value={qrOptions.bgColor || "#ffffff"} onChange={handleBgColorChange} />
                    <input type="text" value={qrOptions.bgColor || "#ffffff"} onChange={handleBgColorChange} />
                </div>
                {colorMode === "gradient" && (
                    <GradientColors qrOptions={qrOptions} handleGradientColorChange={handleGradientColorChange} gradientType={gradientType} handleGradientTypeChange={handleGradientTypeChangeWithUpdate} />
                )}
            </div>
            <div className="form-group toggle-dots-options" onClick={toggleDotsOptions}>
                <i id="toggle-dots-options" className="fas fa-cog change-icon" title="Mudar Tipo dos Pontos"></i>
                <span>Mudar pontos</span>
            </div>
            <div id="dots-options" style={{ display: isDotsOptionsVisible ? 'flex' : 'none' }}>
                <div className="dots-option selected" data-type="square" onClick={() => handleDotsTypeChange("square")}>
                    <img src="imagens/qrc/qrc-quadrado.webp" alt="Quadrado" />
                </div>
                <div className="dots-option" data-type="dots" onClick={() => handleDotsTypeChange("dots")}>
                    <img src="imagens/qrc/qrc-pontos.webp" alt="Pontos" />
                </div>
                <div className="dots-option" data-type="rounded" onClick={() => handleDotsTypeChange("rounded")}>
                    <img src="imagens/qrc/qrc-arredondado.webp" alt="Arredondado" />
                </div>
                <div className="dots-option" data-type="classy" onClick={() => handleDotsTypeChange("classy")}>
                    <img src="imagens/qrc/qrc-elegante.webp" alt="Elegante" />
                </div>
                <div className="dots-option" data-type="classy-rounded" onClick={() => handleDotsTypeChange("classy-rounded")}>
                    <img src="imagens/qrc/qrc-elegante-arredondado.webp" alt="Elegante Arredondado" />
                </div>
                <div className="dots-option" data-type="extra-rounded" onClick={() => handleDotsTypeChange("extra-rounded")}>
                    <img src="imagens/qrc/qrc-extra-arredondado.webp" alt="Extra Arredondado" />
                </div>    
            </div>
            <TrackingModal
                isOpen={isTrackingModalOpen}
                onClose={handleTrackingModalClose}
            />
        </div>
    );
};

export default ControlOptions;